// extracted by mini-css-extract-plugin
module.exports = {"header":"LogoutHeader_header__17juP","logo":"LogoutHeader_logo__m5q_H","label":"LogoutHeader_label__2QjmE"};